<div class="careers-layout container-default bg-white pb-0">
  <section class="hero-background" role="img" aria-label="[equipment make and model] sitting idle and waiting to be rented on Rubbl">
    <div class="container-sm">
      <div class="row">
        <div class="my-5 mx-4 mx-lg-4">
          <div>
            <h1 class="jumbotron-header text-white">Join the Rubbl Team</h1>
            <p class="subhead-2 text-white">We are actively seeking driven individuals with a passion for sales to join our dynamic team.</p>
          </div>
          <div>
            <!-- <a class="btn btn-primary btn-lg" href="mailto:jobs@rubbl.com">Submit resume</a> -->
          </div>
        </div>
      </div>
    </div>
  </section>
  <div class="container container-sm">
    <section>
      <p class="subhead-2 mt-4">
        Rubbl is the first fully-managed online heavy equipment rental marketplace, providing real-time access to high-quality vetted contractor-owned
        equipment. We welcome individuals who thrive in fast-paced environments, possess excellent communication skills, and are eager to make a significant
        impact on Rubbl's journey towards excellence.
      </p>
      <!-- <p class="font-weight-light fs-13 mt-3 text-muted">
        If button does not work please send us your resume to <a href="mailto:jobs@rubbl.com">{{ "jobs@rubbl.com" }}</a>
      </p> -->

      <div class="row mt-5">
        <div class="col-md-4" *ngFor="let marketingCard of marketingCards; index as i">
          <common-marketing-card [marketingCard]="marketingCard"></common-marketing-card>
        </div>
      </div>

      <h3 class="bb-light mt-5 w-100">Current openings</h3>

      <dl class="mt-3">
        <dt class="font-weight-bold">None</dt>
      </dl>

      <!-- <dl class="mt-3">
        <dt class="font-weight-bold">Outside Sales Representative</dt>
        <dd>
          Responsible for expanding our customer base and fostering long-term relationships with clients through effective lead generation, nurturing contacts,
          and utilizing various sales approaches.
        </dd>
        <dd><a href="https://company.rubbl.com/pubweb/jobs/outside-sales-rep.docx">See job description</a></dd>
      </dl> -->
      <div class="bb-light my-3"></div>
      <p class="subhead-2 mb-5 pb-5">
        If this sounds like the perfect opportunity for your career growth and development, we'd love to hear from you. Please send your resume summary
        highlighting your sales experience and passion for driving success to <a href="mailto:jobs@rubbl.com">{{ "jobs@rubbl.com" }}</a
        >.
      </p>
    </section>
  </div>
</div>
<common-footer></common-footer>
